import { LogoColors } from 'ui/logo';
import { AnimationContainer, LoadingLogo } from './Spinner.styled';

type Props = {
  /** dimension that determines diamond width and height */
  size?: number;
  /** The color variant of the logo */
  color?: LogoColors;
};

export const Spinner = ({ size = 36, color = LogoColors.COLOR, ...props }: Props) => (
  <AnimationContainer data-test="loading-wrapper" {...props}>
    <LoadingLogo aria-label="Loading data" data-test="loading-logo" height={size} color={color} />
  </AnimationContainer>
);
